"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OVERVIEW = void 0;
var OVERVIEW = {
  BUTTON__EDIT_SUPPLIER: 'logOfflineOrderFlow-button-editSupplier',
  BUTTON__EDIT_PRODUCTS: 'logOfflineOrderFlow-button-editProducts',
  BUTTON__DELIVERY_FEE: 'logOfflineOrderFlow-button',
  BUTTON__UPLOAD_INVOICE: 'logOfflineOrderFlow-button-uploadInvoice'
};
exports.OVERVIEW = OVERVIEW;